import styled, { css, keyframes } from "styled-components";

const fadeUp = keyframes`
    from { opacity: 0; transform: translateY(6px) scale(0.96); }
    to   { opacity: 1; transform: translateY(0)   scale(1);    }
`;

const popIn = keyframes`
    0%   { transform: scale(1);   }
    50%  { transform: scale(1.2); }
    100% { transform: scale(1.1); }
`;

export const StyledRoot = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    pointer-events: auto;
    user-select: none;
    -webkit-user-select: none;
`;

export const StyledPresetsRow = styled.div<{ $hidden: boolean }>`
    display: flex;
    align-items: center;
    gap: 5px;
    touch-action: none;
    transition:
        opacity 0.22s ease,
        transform 0.22s ease;

    ${({ $hidden }) =>
        $hidden &&
        css`
            opacity: 0;
            transform: translateY(4px);
            pointer-events: none;
        `}
`;

export const StyledPresetBtn = styled.button<{ $active: boolean }>`
    height: 34px;
    min-width: 34px;
    padding: 0 10px;
    border: none;
    border-radius: 17px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: -0.2px;
    outline: none;
    touch-action: none;
    transition:
        background 0.18s,
        color 0.18s,
        box-shadow 0.18s,
        transform 0.22s cubic-bezier(0.34, 1.56, 0.64, 1);

    ${({ theme, $active }) =>
        $active
            ? css`
                  background: ${theme.colors.yellowAccent};
                  color: ${theme.colors.black};
                  transform: scale(1.1);
                  box-shadow: 0 2px 14px ${theme.colors.yellowAccent}80;
                  animation: ${popIn} 0.25s ease both;
              `
            : css`
                  background: ${theme.primaryBackground}cc;
                  color: ${theme.inactiveTabColor};
                  backdrop-filter: blur(14px);
                  -webkit-backdrop-filter: blur(14px);

                  &:hover {
                      background: ${theme.secondaryBackgroundColor}cc;
                      transform: scale(1.06);
                  }
                  &:active {
                      transform: scale(0.95);
                  }
              `}
`;

export const StyledSliderZone = styled.div<{ $visible: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    overflow: hidden;
    max-height: ${({ $visible }) => ($visible ? "80px" : "0")};
    opacity: ${({ $visible }) => ($visible ? 1 : 0)};
    transform: ${({ $visible }) =>
        $visible ? "translateY(0)" : "translateY(6px)"};
    transition:
        max-height 0.22s ease,
        opacity 0.22s ease,
        transform 0.22s ease;
    pointer-events: ${({ $visible }) => ($visible ? "auto" : "none")};

    ${({ $visible }) =>
        $visible &&
        css`
            animation: ${fadeUp} 0.22s ease both;
        `}
`;

export const StyledZoomBadge = styled.div`
    background: ${({ theme }) => theme.secondaryBackground}e0;
    border: 1.5px solid ${({ theme }) => theme.colors.yellowAccent};
    color: ${({ theme }) => theme.colors.yellowAccent};
    font-size: 13px;
    font-weight: 700;
    padding: 3px 11px;
    border-radius: 20px;
    letter-spacing: 0.5px;
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    min-width: 52px;
    text-align: center;
`;

export const StyledRulerWrap = styled.div`
    position: relative;
    width: 220px;
    height: 32px;
    display: flex;
    align-items: center;
    overflow: hidden;
`;

export const StyledTicksRow = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    position: absolute;
    left: 50%;
    will-change: transform;
`;

export const StyledTick = styled.div<{ $size: "large" | "medium" | "small" }>`
    width: 1.5px;
    border-radius: 1px;
    flex-shrink: 0;
    background: ${({ theme }) => theme.secondaryTypographyColor};
    opacity: 0.5;
    height: ${({ $size }) =>
        $size === "large" ? "22px" : $size === "medium" ? "13px" : "7px"};
`;

export const StyledCenterLine = styled.div`
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 2px;
    height: 26px;
    background: ${({ theme }) => theme.colors.yellowAccent};
    border-radius: 1px;
    box-shadow: 0 0 8px 1px ${({ theme }) => theme.colors.yellowAccent}aa;
    pointer-events: none;
`;
